module.exports = "/_next/static/images/e557886529ed41cdf37a218da068b9f0-background@3x.png";